export const environment = {
  production: false,
  baseUrl: 'https://gbc-api.integration.clesame.fr/api',
  builderApiKey: '783b77f4d3a24b4aa7db9dd0532ef908',
}
